import React from "react";
import { jobSeekerData } from "../../../jobseekerComponents/jobseekerSidebar/sidebarData";
import NavBarComponent from "../../NavBarComponent";
import { internalLinks, links } from "./navigationData";

const index = () => {
  const extraLinks = jobSeekerData;
  extraLinks.map((e) => (e.link = e.path));
  console.log("these are", extraLinks);
  return (
    <NavBarComponent
      links={links}
      internalLinks={internalLinks}
      extaLinks={extraLinks}
    />
  );
};

export default index;
